import React from 'react'
import Footer from '../../components/Footer/Footer'
import Nav from '../../components/Nav/Nav'
import './SitePage.sass'
import Top from '../../components/Top/Top'
import Hero from '../../components/Hero/Hero'
import heroBg from './assets/heroBg.jpg'

function SitePage({ children }) {
  return (
    <>
      <div
        className="BackgoundMerged"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <Top />
        <Nav />
        <Hero />
      </div>
      {children}
      <Footer />
    </>
  )
}

export default SitePage
